import {devAccessActionTypes as types} from '../actions/actionTypes';

const initialState = {
  apiKey: null,
  apiSecret: null,
  accessToken: null,
  isLoading: false,
  isLoadingAPIKey: false,
  isLoadingToken: false,
  loadFailed: false,
  refreshToken: null,
  tokenExpiration: null,
};

export default function billing(state = initialState, action) {
  switch (action.type) {
    case types.DEV_ACCESS_LOADING:
      return {...state, isLoading: true};

    case types.DEV_ACCESS_COMPLETE:
      return {...state, ...action.data, isLoading: false};

    case types.DEV_ACCESS_FAIL:
      return {...state, isLoading: false, loadFailed: true};

    case types.GET_API_KEY_LOADING:
      return {...state, isLoadingAPIKey: true};

    case types.GET_API_KEY_COMPLETE:
      return {...state, ...action.data, isLoadingAPIKey: false};

    case types.GET_TOKEN_LOADING:
      return {...state, isLoadingToken: true};

    case types.GET_TOKEN_COMPLETE:
      return {...state, ...action.data, isLoadingToken: false};

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/devAccessReducer.js